import Lottie from "lottie-react";
import animationData from "./folder-no-data.json";

interface LottieAnimationProps {
  height?: number;
  width?: number;
  loop?: boolean;
}

export function NoDataAnimation({
  height = 300,
  width = 300,
  loop = true,
}: LottieAnimationProps) {
  return (
    <div style={{ height, width }}>
      <Lottie animationData={animationData} loop={loop} />
    </div>
  );
}
